export const parseHex = (hex: string, delta: number) => {
  return Math.min(255, Math.max(0, parseInt(hex, 16) + delta));
};

export const hexToRgb = (hexCode: string, alpha: number, delta: number = 0): string => {
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hexCode);

  if (result) {
    const r = parseHex(result[1], delta);
    const g = parseHex(result[2], delta);
    const b = parseHex(result[3], delta);

    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
  }

  return 'rgba(0,0,0,1)';
};

export const isWhite = (hex?: string | null) => {
  if (!hex) return true;

  // Remove the hash and expand shorthand hex (e.g., "f00" -> "ff0000")
  let cleanHex = hex.replace('#', '');

  if (cleanHex.length === 3) {
    cleanHex = cleanHex
      .split('')
      .map((char) => char + char)
      .join('');
  }

  // Convert hex to RGB integers
  const r = parseInt(cleanHex.substring(0, 2), 16);
  const g = parseInt(cleanHex.substring(2, 4), 16);
  const b = parseInt(cleanHex.substring(4, 6), 16);

  // Calculate Relative Luminance
  // This formula accounts for how human eyes perceive different colors.
  // Weights: Green (71.5%) > Red (21.2%) > Blue (7.2%)
  const luminance = (0.2126 * r + 0.7152 * g + 0.0722 * b) / 255;

  // 1 is white, 0 is black
  // tolerance can be adjusted if needed
  return luminance > 0.5;
};
